import GoButton from './GoButton';

export default GoButton;
